module.exports = __webpack_public_path__ + "static/media/map-marker-question.928330b7.svg";